<template>
  <div>
    <div v-if="$mq.lg" class="flex justify-end pl-4">
      <div @click="dropdownToggle = !dropdownToggle" class="z-50 cursor-pointer flex items-center">
        <div class="avatar bg-light-gray-4 font-bold rounded-full w-40 h-40 flex items-center justify-center">
          {{ initials }}
        </div>
      </div>

      <div v-if="dropdownToggle"
        class="absolute bg-white sign-out-panel mt-18 shadow-lg z-20 px-16 pt-10 fit-content rounded-md">
        <p class="no-wrap py-16 border-b border-gray text-center mb-10">
          Hi, {{ fullname }}!
        </p>
        <a href="/sign-out" class="block pt-10 pb-20 w-full">
          <i class="fas fa-arrow-from-left mr-8"></i> Sign Out
        </a>
      </div>
    </div>

    <div v-else>
      <a href="/sign-out">
        <button class="btn btn-primary-black w-full text-center rounded-full">
          <i class="fas fa-arrow-from-left mr-8"></i> Sign Out
        </button>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "UserButton",

  props: {
    fullname: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      dropdownToggle: false,
    };
  },

  computed: {
    initials() {
      const [firstName, lastName] = this.fullname.split(" ")

      return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase()
    },
  },
};
</script>

<style scoped>
.no-wrap {
  white-space: nowrap;
}

.sign-out-panel {
  margin-top: 48px;
  border: 1px #cacaca solid;
}
</style>
